/**
 * Expandable outcome row in the bulk status panel (label, count, RMA id list).
 */
import { useState } from "react";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import IconChevronDown from "../../../../../components/icons/icon-chevron-down/icon-chevron-down";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { IBulkStatusPanelRow } from "../../stores/bulk-status-panel-store";

interface IProps {
    row: IBulkStatusPanelRow;
}

const RmaListBulkStatusPanelRow: React.FC<IProps> = ({ row }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";
    const [expanded, setExpanded] = useState(false);
    const label = row.labelText ?? getTranslation(row.labelKey, scope);

    return (
        <div className={`rma-list-bulk-status-panel__row-container${expanded ? " expanded" : ""}`}>
            <button
                type="button"
                className="rma-list-bulk-status-panel__row"
                onClick={() => setExpanded((prev) => !prev)}
                aria-expanded={expanded}
            >
                <span className="rma-list-bulk-status-panel__row-label">
                    <FontBody2 color={FONT_COLOR.PRIMARY2}>{label}</FontBody2>
                </span>
                <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                    {String(row.count)}
                </FontBody2>
                <span className={`rma-list-bulk-status-panel__chevron${expanded ? " open" : ""}`}>
                    <IconChevronDown color="var(--color-accent-4)" />
                </span>
            </button>
            {expanded && (
                <div className="rma-list-bulk-status-panel__ids">
                    <div className="rma-list-bulk-status-panel__ids-header">
                        <FontBody2 color={FONT_COLOR.PRIMARY2}>
                            {getTranslation("BULK_STATUS_RMA_TABLE_HEADER", scope)}
                        </FontBody2>
                    </div>
                    <div className="rma-list-bulk-status-panel__ids-body">
                        {row.rmaIds.map((rmaId) => (
                            <div key={rmaId} className="rma-list-bulk-status-panel__ids-row">
                                <FontBody2 color={FONT_COLOR.PRIMARY2}>
                                    {getTranslation("RMA", scope)}
                                    {rmaId}
                                </FontBody2>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default RmaListBulkStatusPanelRow;
